
import { Link } from 'react-router-dom';


import blogImg1 from '../../assets/images/blog/blog-1.png';

const SinglePost = (props) => { 
    const { blogClass, blogID, blogImage, blogTitle, blogCategory, blogAuthor, blogPublishedDate,slug,desc } = props;
    return (
        <div className={blogClass ? blogClass : 'blog__card mb-50'}>
            <div className="blog__thumb w-img p-relative " style={{height:"200px"}}>
                <Link
                    to={`/blog/${slug}`}
                    className="blog__thumb--image"
                >
                    <img 
                        src={blogImage} 
                        alt={blogTitle}
                        width={300}
                        style={{objectFit:"cover",height:"100%"}}
                        height={200}
                        
                    />
                </Link>
                {/* <em className="b_date " style={{background:'#002F6D'}}>{blogPublishedDate ? blogPublishedDate?.split("T")[0] : ''}</em> */}
            </div>
            <div className="blog__card--content p-3">
                <div className="blog__card--content-area mb-25">
                  <Link to={`/blog/${slug}`}>  <h2 className="blog__card--title mb-2" >{blogTitle}</h2></Link>
                    <p className="text-dark"><Link to={`/blog/${slug}`} className='text-dark'>{desc}</Link></p>
                </div>
                {/* <div className="blog__card--icon d-flex align-items-center">
                    <div className="blog__card--icon-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        <span>{blogAuthor ? blogAuthor : 'Charlie Doyle'}</span>
                    </div>  
                </div> */}
            </div>
        </div>

    )
}

export default SinglePost